/* First-order discount popup (Checkpoint 10).
   Native <dialog> supplies the focus trap and Escape handling. */
class FuliliWelcomePopup extends HTMLElement {
  static STORAGE_KEY = 'fulili-welcome-dismissed-at';

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || this.isDismissed()) return;

    this.dialog.addEventListener('close', () => this.remember());
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.dialog.close(); // backdrop click
    });
    this.querySelector('.welcome-popup__close')?.addEventListener('click', () => this.dialog.close());
    this.querySelector('.welcome-popup__cta')?.addEventListener('click', () => this.remember());

    const copyBtn = this.querySelector('[data-copy]');
    copyBtn?.addEventListener('click', async () => {
      const code = this.querySelector('[data-code]')?.textContent.trim() || '';
      try {
        await navigator.clipboard.writeText(code);
        this.flashCopied(copyBtn);
      } catch (err) {
        const range = document.createRange();
        range.selectNodeContents(this.querySelector('[data-code]'));
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    });

    const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
    setTimeout(() => {
      if (!this.isDismissed() && !this.dialog.open) this.dialog.showModal();
    }, delay);
  }

  flashCopied(btn) {
    const label = btn.querySelector('[data-copy-label]');
    if (!label) return;
    const original = label.textContent;
    label.textContent = 'Copied!';
    btn.disabled = true;
    setTimeout(() => {
      label.textContent = original;
      btn.disabled = false;
    }, 2000);
  }

  isDismissed() {
    // Reviewer hook: ?show_welcome=1 forces the popup past dismissal memory.
    if (new URLSearchParams(location.search).get('show_welcome') === '1') return false;
    try {
      const at = parseInt(localStorage.getItem(FuliliWelcomePopup.STORAGE_KEY), 10);
      if (!at) return false;
      const days = parseInt(this.dataset.dismissDays, 10) || 90;
      return Date.now() - at < days * 86400000;
    } catch (err) {
      return false;
    }
  }

  remember() {
    try {
      localStorage.setItem(FuliliWelcomePopup.STORAGE_KEY, String(Date.now()));
    } catch (err) {
      /* storage unavailable: fail open, popup just reappears next visit */
    }
  }
}

customElements.define('fulili-welcome-popup', FuliliWelcomePopup);
